var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldSelectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36.759,
    viewBox: "0 0 28 36.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-61 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11856",
    "data-name": "Path 11856",
    d: "M158.538,150a7.538,7.538,0,1,0,7.538,7.538A7.547,7.547,0,0,0,158.538,150Zm5.069,6.146-5.744,5.744a1.077,1.077,0,0,1-1.523,0l-2.872-2.872a1.077,1.077,0,1,1,1.523-1.523l2.11,2.11,4.982-4.982a1.077,1.077,0,0,1,1.523,1.523Z",
    transform: "translate(-83.538 -139.23)",
    fill: "#df9426"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11857",
    "data-name": "Path 11857",
    d: "M87.923,5.744A16.15,16.15,0,0,1,76.428.983L75.762.316a1.077,1.077,0,0,0-1.523,0l-.667.667A16.149,16.149,0,0,1,62.077,5.744,1.077,1.077,0,0,0,61,6.821V17.563A20.248,20.248,0,0,0,74.649,36.7a1.078,1.078,0,0,0,.7,0A20.248,20.248,0,0,0,89,17.563V6.821a1.077,1.077,0,0,0-1.077-1.077ZM75,28a9.692,9.692,0,1,1,9.692-9.692A9.7,9.7,0,0,1,75,28Z",
    transform: "translate(0 0)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldSelectedIcon);
export default __webpack_public_path__ + "static/media/shield_selected_icon.d89beeb3673f0b1382789cdab6d1ffdf.svg";
export { ForwardRef as ReactComponent };